import { css } from "styled-components"

const sizes = {
  desktop: 992,
  tablet: 768,
  chTablet: 600,
  phone: 476
}

const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${sizes[label] / 16}em) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const colors = {
  text: `#0C121C`
}

module.exports = media



// WEBPACK FOOTER //
// ./src/utils/media.js